import * as React from 'react';
import {
  BoundingBox,
  DocumentContext,
  scrollToId,
} from '@allenai/pdf-components'; // eslint-disable-line import/no-unresolved
import { BoundingBox as BoundingBoxType } from '@allenai/pdf-components/src/components/types/boundingBox'; // eslint-disable-line import/no-unresolved

type Props = {
  pageIndex: number;
  boxes?: BoundingBoxType[];
  offsetX?: number;
  offsetY?: number;
};

const DEFAULT_OFFSET = { x: 0, y: 0 };

const INTERNAL_SCROLL_ID = '__INTERNAL_SCROLL_TO_ID__';
export const ScrollToOnChange: React.FunctionComponent<Props> = (props) => {
  const {
    pageIndex,
    boxes: unscaledBoxes,
    offsetX = DEFAULT_OFFSET.x,
    offsetY = DEFAULT_OFFSET.y,
  } = props;
  const { pageDimensions } = React.useContext(DocumentContext);
  const boxes = React.useMemo(() => {
    return (unscaledBoxes ?? []).map((box) => {
      return {
        page: box.page,
        top: box.top * pageDimensions.height,
        left: box.left * pageDimensions.width,
        width: box.width * pageDimensions.width,
        height: box.height * pageDimensions.height,
      };
    });
  }, [unscaledBoxes, pageDimensions.width, pageDimensions.height]);
  const scrollToBox: BoundingBoxType | undefined = React.useMemo(() => {
    return boxes?.[0]?.page === pageIndex
      ? {
          width: boxes[0].width,
          height: boxes[0].height,
          top: boxes[0].top + offsetY,
          left: boxes[0].left + offsetX,
          page: boxes[0].page,
        }
      : undefined;
  }, [boxes, offsetX, offsetY]);
  React.useEffect(() => {
    console.log('Scroll to demo figure from useEffect');
    if (!boxes || pageIndex !== boxes?.[0]?.page) {
      return undefined;
    }
    const timeout = setTimeout(() => scrollToId(INTERNAL_SCROLL_ID), 1000);
    return () => clearTimeout(timeout);
  }, [
    scrollToBox?.height,
    scrollToBox?.left,
    scrollToBox?.page,
    scrollToBox?.top,
    scrollToBox?.width,
  ]);

  return (
    <>
      {scrollToBox && (
        <BoundingBox
          underlineClassName="do_not_underline"
          id={INTERNAL_SCROLL_ID}
          {...scrollToBox}
          isHighlighted={false}
        />
      )}
      {(boxes ?? []).map((box) => {
        if (box.page !== pageIndex) {
          return null;
        }
        return (
          <BoundingBox
            underlineClassName="reader__yellow_background_highlight"
            {...box}
            isHighlighted={false}
            key={`${box.top}_${box.left}`}
          />
        );
      })}
    </>
  );
};
